import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20creative%20workspace%20with%20warm%20amber%20and%20sage%20green%20color%20palette%20abstract%20flowing%20gradient%20shapes%20soft%20organic%20forms%20collaborative%20environment%20atmosphere%20artistic%20editorial%20photography%20with%20gentle%20diffusion%20and%20harmonious%20composition&width=1800&height=900&seq=hero-bg-yiqicao&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 pt-20 md:pt-24 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/20 backdrop-blur-sm border border-background-50/20 rounded-full mb-6">
          <span className="w-2 h-2 bg-accent-400 rounded-full animate-pulse"></span>
          <span className="text-xs md:text-sm text-background-50/90 font-medium">
            V3.0 全新上线 · AI智能辅助写作
          </span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          让每一次
          <span className="relative inline-block mx-2">
            <span className="relative z-10 text-primary-300">一起草</span>
            <span className="absolute bottom-1 left-0 right-0 h-3 bg-primary-500/30 -z-0 rounded-full"></span>
          </span>
          都高效顺畅
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          专为团队打造的多人协同文稿创作平台，支持实时共同编辑、版本管理与智能审阅。
          告别反复传文件的烦恼，让每一次文稿协作都事半功倍。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-200 text-base whitespace-nowrap"
          >
            免费开始使用
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/hetong-wenshu"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 border border-background-50/30 font-medium rounded-lg transition-all duration-200 text-base whitespace-nowrap"
          >
            探索应用场景
            <i className="ri-arrow-down-line ml-2"></i>
          </Link>
        </div>

        <div className="mt-12 md:mt-16 flex items-center justify-center gap-8 md:gap-12">
          {[
            { value: '50万+', label: '活跃用户' },
            { value: '2万+', label: '企业团队' },
            { value: '99.9%', label: '服务可用率' },
          ].map((item, idx) => (
            <div key={idx} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{item.value}</div>
              <div className="text-xs md:text-sm text-background-50/60 mt-1">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}